/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for updating a remote MCP server header. Replaces every mutable field, so omitted optional fields are reset to their defaults. The one exception is value: omitting it for a header that is already secret preserves the stored value rather than clearing it.
 */
export type UpdateServerHeaderForm = {
  /**
   * Description of the header
   */
  description?: string | undefined;
  /**
   * The ID of the header to update
   */
  id: string;
  /**
   * Whether the header is required. Defaults to false.
   */
  isRequired?: boolean | undefined;
  /**
   * Whether the header value is a secret. Defaults to false. Incompatible with value_from_request_header.
   */
  isSecret?: boolean | undefined;
  /**
   * The header name
   */
  name: string;
  /**
   * Static header value (mutually exclusive with value_from_request_header). Omit on an existing secret header to preserve its stored value.
   */
  value?: string | undefined;
  /**
   * Name of the inbound request header to pass through (mutually exclusive with value)
   */
  valueFromRequestHeader?: string | undefined;
};

/** @internal */
export type UpdateServerHeaderForm$Outbound = {
  description?: string | undefined;
  id: string;
  is_required?: boolean | undefined;
  is_secret?: boolean | undefined;
  name: string;
  value?: string | undefined;
  value_from_request_header?: string | undefined;
};

/** @internal */
export const UpdateServerHeaderForm$outboundSchema: z.ZodMiniType<
  UpdateServerHeaderForm$Outbound,
  UpdateServerHeaderForm
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    id: z.string(),
    isRequired: z.optional(z.boolean()),
    isSecret: z.optional(z.boolean()),
    name: z.string(),
    value: z.optional(z.string()),
    valueFromRequestHeader: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      isRequired: "is_required",
      isSecret: "is_secret",
      valueFromRequestHeader: "value_from_request_header",
    });
  }),
);

export function updateServerHeaderFormToJSON(
  updateServerHeaderForm: UpdateServerHeaderForm,
): string {
  return JSON.stringify(
    UpdateServerHeaderForm$outboundSchema.parse(updateServerHeaderForm),
  );
}
